import React, { useEffect, useState } from 'react';
import { getQueueCount, syncQueuedMutations } from '../services/offlineStore';
import api from '../services/api';
import './OfflineStatus.css';

export default function OfflineStatus() {
  const [status, setStatus] = useState({ online: navigator.onLine, pending: 0, syncing: false, syncError: '' });
  const visible = !status.online || status.pending > 0 || status.syncing || Boolean(status.syncError);

  useEffect(() => {
    let active = true;
    getQueueCount().then((pending) => active && setStatus((current) => ({ ...current, pending })));
    const update = (event) => setStatus((current) => ({ ...current, ...event.detail }));
    window.addEventListener('cultivamais:offline-status', update);
    return () => {
      active = false;
      window.removeEventListener('cultivamais:offline-status', update);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle('cm-offline-status-visible', visible);
    return () => document.body.classList.remove('cm-offline-status-visible');
  }, [visible]);

  if (!visible) return null;

  const sync = () => syncQueuedMutations(api.defaults.baseURL);
  const label = status.syncing
    ? 'Sincronizando dados...'
    : status.online
      ? `${status.pending} operação${status.pending === 1 ? '' : 'ões'} aguardando envio`
      : `Modo offline · ${status.pending} pendente${status.pending === 1 ? '' : 's'}`;

  return (
    <div className={`offline-status ${status.online ? 'is-online' : 'is-offline'} ${status.syncError ? 'has-error' : ''}`} role="status" aria-live="polite">
      <i className={`bi ${status.syncing ? 'bi-arrow-repeat offline-spin' : status.online ? 'bi-cloud-arrow-up' : 'bi-cloud-slash'}`} />
      <span>
        <strong>{label}</strong>
        {status.syncError && <small>Não foi possível enviar: {status.syncError}</small>}
        {!status.online && <small>Continue trabalhando. Os dados serão enviados quando a conexão voltar.</small>}
      </span>
      {status.online && status.pending > 0 && !status.syncing && <button type="button" onClick={sync}>Sincronizar</button>}
    </div>
  );
}
